export const ApiKeys = {
	weatherAPI: '93684f29575e892abf2356870f3dc8b2'
}